import Backbone from 'backbone'
import template from './edit-buttons.hbs'
import deleteDomainObject from './delete-domain-object'
import appDisplay from 'scoreboard/components/app-display'
import PasteForm from 'scoreboard/components/paste/copy-move-destination-form'
import i18n from 'scoreboard/components/i18n'
import guard from 'scoreboard/components/unsaved/guard'
import Tooltip from 'scoreboard/components/tooltip'
import _ from 'lodash'
import permissions from 'scoreboard/components/permissions'
import highlight from 'scoreboard/components/highlight'
import config from 'scoreboard/components/config'
import { isV5 } from 'scoreboard/components/version'

var EditButtons = Backbone.View.extend({

	// this.model is a domain object, e.g. a Document

	className: 'edit-buttons',

	events: {
		'click .move': 'move',
		'click .copy': 'copy',
		'click .save': 'save',
		'click .cancel': 'cancel',
		'click .delete': 'delete'
	},

	/**
	 * Initializes with the following options:
	 *
	 * @param {Object} options.model the model
	 * @param {String} [options.pasteUrl] a custom URL to use for pasting
	 * @param {Function} [options.pasteAllowed] function that determines if a
	 * paste is allowed
	 * @param {Object} [options.alertNotificationPrompt] - a hash of events
	 * that should show a notification prompt checkbox which will generate alerts
	 * @param {Boolean} [options.alertNotificationPrompt.delete=false]
	 * @param {Boolean} [options.disableMoveButton=false] hides the move button
	 * @param {Boolean} [options.disableCopyButton=false] hides the copy button
	 * move/copy/delete buttons if true
	 */
	initialize: function(options) {
		if (!options || !options.model) {
			alert('model is required')
			debugger
		}
		if (!options.model.section) {
			console.error('the model must have a section')
		}

		this.options = options

		this.listenTo(this.model, 'sync', this._updateState.bind(this))
	},

	render: function() {
		this.$el.empty().append(template({
			disableMoveButton: this.options.disableMoveButton,
			disableCopyButton: this.options.disableCopyButton
		}))
		this._updateState()
		return this
	},

	_addDisabledByRepTooltip (evt, msgKey) {
		evt.stopPropagation()
		_.invoke(this._disabledByReplicationTooltip, 'remove')
		this._disabledByReplicationTooltip = new Tooltip({
			attachTo: evt.target,
			content: i18n.get(msgKey),
			placement: 'above',
			arrow: 'center'
		}).render()
	},

	_updateState: function () {
		let orgCopy
		if (this.options.section === 'scorecards') {
			// scorecard templates are only available for the entire organization, so
			// if the item has a template, that it's the entire org
			orgCopy = !!this.model.get('templateId')

			//scorecard nodes have special logic on what can be edited depending on replcation attributes
			if (this.model.get('dereferenced')) {
				this.$('.copy').addClass('is-disabled')
					.click(evt => this._addDisabledByRepTooltip(evt,'common.replication.onlyMoveDelete'))

				//#19549 prevent moving dereferenced root docking
				if (this.model.get('type') == 'root') {
					this.$('.move').addClass('is-disabled')
						.click(evt => this._addDisabledByRepTooltip(evt,'common.replication.onlyDelete'))
				}
			} else if (this.model.replicated()) {
				//for most replicated objects you cannot move/delete/copy
				let selectors = '.move, .delete, .copy'
				if (this.model.transformedDocking()) {
					//except if transformed docking, can do special kind of delete
					selectors = '.move, .copy'
					this.$('.delete').text(i18n.get('common.replication.deleteDescendants'))
					this.options.confirmDeleteMessage = i18n.get('common.delete.confirmation.onlyDescendants',
						highlight(this.model.get('label')))
				}
				this.$(selectors).addClass('is-disabled')
					.click(evt => this._addDisabledByRepTooltip(evt,'integrity.scorecards.unmodifiableSyncNode'))
			}

			//#21508 don't allow copy of docking nodes on the NIPR
			if (config.replicationOutputEnabled && !this.model.isNew() && this.model.get('type') === 'docking' ) {
				this.$('.copy').addClass('is-disabled')
					.click(evt => this._addDisabledByRepTooltip(evt,'common.replication.noCopyDockingNodes'))
			}

		} else {
			// individual dashboards and reports can be templates, so we need to explicitly check
			// that its organization has a template
			orgCopy = this.model.get('organizationIsCopy')

			//replicate objects cannot be modified
			if (!permissions.isEditableIfReplicated(this.model)) {
				this.$('.move, .delete, .copy').addClass('is-disabled')
					.click(evt => this._addDisabledByRepTooltip(evt,'integrity.scorecards.unmodifiableSyncNode'))
			}
		}

		let allowMoveAndDelete = true
		if (this.model.isNew()) {
			// Can't move or delete a domain object that hasn't been saved yet
			allowMoveAndDelete = false
		} else if (this.model.get('templateId') && orgCopy) {
			// Can't move a template copy if it's part of an org copy
			// #25611 However, can move a standalone (non-copy) domain object
			// that's in an org copy
			allowMoveAndDelete = false
		}

		this.$('.move, .delete').toggleClass('is-not-displayed', !allowMoveAndDelete)

		this.$('.copy')
			.toggleClass('is-not-displayed', this.model.isNew())
			// if move button is hidden b/c it's a template copy, copy button should be a single non-joined button
			.toggleClass('button-right-joined', !orgCopy && isV5())

		var label = this.$('.save .label')
		var toChange = label.length > 0 ? label : this.$('.save')
		toChange.text(i18n.get(this.model.isNew() ? 'common.create' : 'common.save'))
	},

	cancel: function() {
		this.trigger('cancel')
	},

	move: function(e) {
		this.paste(e, 'move')
	},

	copy: function(e) {
		this.paste(e, 'copy')
	},

	save: function() {
		this.trigger('save')
	},

	paste: function(e, mode) {
		guard.conditionallyRun(function() {
			var pasteForm = new PasteForm({
				url: this.options.pasteUrl,
				section: this.model.section,
				domainType: this.model.domainType,
				mode: mode,
				object: this.model.attributes,
				pasteAllowed: this.options.pasteAllowed
			})
			appDisplay.dialog(pasteForm)
		}.bind(this))
	},

	'delete': function() {
		deleteDomainObject(this)
			.on('done', resp => this.trigger('deleted', resp))
	},

	remove () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._disabledByReplicationTooltip], 'remove')
	}

})

export default EditButtons

EditButtons.__filename__ = 'components/edit/edit-buttons.js'
